import SDIcon from './SDIcon'

const IconCarbonFinance = (props) => (
  <SDIcon title='Finance' {...props}>
    <rect x='2' y='28' width='28' height='2' />
    <path
    d='M27,11a1,1,0,0,0,1-1V7a1,1,0,0,0-.66-.94l-11-4a1,1,0,0,0-.68,0l-11,4A1,1,0,0,0,4,7v3a1,1,0,0,0,1,1H6V24H4v2H28V24H26V11ZM6,7.7,16,4.06,26,7.7V9H6ZM18,24H14V11h4ZM8,11h4V24H8ZM24,24H20V11h4Z'
    transform='translate(0 0)'
    />
  </SDIcon>
)

export default IconCarbonFinance
